import { Step, StepLabel, Stepper } from '@mui/material';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { StepsControl } from '../../constants';

interface IFormCard {
  children: JSX.Element;
  currentStep: number;
  activeStep: number;
}

const FormCard = ({ children, currentStep, activeStep }: IFormCard) => {
  const { t } = useTranslation();

  const [completed, setCompleted] = React.useState<{
    [k: number]: boolean;
  }>({});

  const steps = [
    t('regGeneralInformation'),
    t('regCompanyInformation'),
    t('regTerms'),
  ];

  const handleReset = () => {
    setCompleted({});
  };

  useEffect(
    () => () => handleReset(),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  if (currentStep > StepsControl.TermsInformation) return null;

  return (
    <>
      {currentStep >= StepsControl.GeneralInformation ? (
        <div className="flex flex-row gap-4 w-full justify-around p-3 mb-5">
          <Stepper
            className="flex-wrap w-full max-w-[800px]"
            nonLinear
            activeStep={activeStep}
          >
            {steps.map((label, index) => (
              <Step className="my-1" key={label} completed={completed[index]}>
                <StepLabel color="inherit">{label}</StepLabel>
              </Step>
            ))}
          </Stepper>
        </div>
      ) : null}
      {children}
    </>
  );
};
export default FormCard;
